<script setup>
import { storeToRefs } from 'pinia';
import { inject } from 'vue';
import { useModal } from 'vue-final-modal';
import DashboardCustomMapPopup from '~/dashboard/components/custom-map/dashboard-custom-map-popup.vue';
import { useDashboardCustomStore } from '~/dashboard/store/dashboard-custom.store.js';

const emit = defineEmits(['update']);
const $t = inject('$t');

const dashboard_custom_store = useDashboardCustomStore();

const {
  custom_configuration,
} = storeToRefs(dashboard_custom_store);

const initial_data = computed(() => custom_configuration.value?.map_boundaries || null);

const import_map_popup = useModal({
  component: DashboardCustomMapPopup,
  attrs: {
    onClose() {
      import_map_popup.close();
    },
    onSave(data) {
      emit('update', data);
      import_map_popup.close();
    },
  },
});
</script>

<template>
  <div v-if="initial_data" class="text-sm font-medium mb-4">
    {{ $t('Map data is set') }}
  </div>
  <HawkButton
    type="outlined"
    class="w-fit mb-4"
    @click="import_map_popup.open()"
  >
    {{ $t("Import map") }}
  </HawkButton>
</template>
